export default () => {
    console.info('InMemory error tracker initialised');

    return {
        setUser: (id = null, email = null) => {
            if (!id && !email) {
                return;
            }

            console.log('ErrorTracker set user: ', id, email);
        },

        setAccount: (accountId) => {
            console.log('ErrorTracker set account: ', accountId);
        },

        setExtraContext: () => {
            
        },

        /**
         * @param err {Error} Exception to capture
         * 
         * @return void
         */
        captureException: (err) => {
            if (!err instanceof Error) {
                return;
            }

            console.log('ErrorTracker captured error: ', err);
        },

        /**
         * @param message {string} message to capture
         * 
         * @return void
         */
        captureMessage: (message) => {
            if (typeof message !== 'string') {
                return;
            }

            console.log('ErrorTracker captured message: ', message);
        },
    }
};
